import Vue from 'vue';

import InputError from '@/components/UI/Inputs/InputError.vue';

Vue.component('InputError', InputError);
